import type { Tooltip } from 'bootstrap';

import { getBootstrapTooltip } from './bootstrap-runtime';

const KEY = 'nais-sidebar-collapsed';
let logoutSubmitBound = false;

function bindLogoutSubmit(): void {
    if (logoutSubmitBound) {
        return;
    }

    logoutSubmitBound = true;
    document.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) {
            return;
        }

        const trigger = target.closest<HTMLElement>('[data-action="nais-logout-submit"]');
        if (!trigger) {
            return;
        }

        event.preventDefault();

        const formId = trigger.dataset.formId || 'frm-logoutForm';
        const form = document.getElementById(formId);
        if (!(form instanceof HTMLFormElement)) {
            return;
        }

        if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
            return;
        }

        form.submit();
    });
}

export function initShell(): void {
    const body = document.body;
    const toggles = document.querySelectorAll<HTMLButtonElement>('[data-nais-sidebar-toggle]');

    bindLogoutSubmit();

    if (localStorage.getItem(KEY) === '1') {
        body.classList.add('nais-sidebar-collapsed');
    }
    updateCollapseControls(toggles, body.classList.contains('nais-sidebar-collapsed'));

    toggles.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            body.classList.toggle('nais-sidebar-collapsed');
            const collapsed = body.classList.contains('nais-sidebar-collapsed');
            localStorage.setItem(KEY, collapsed ? '1' : '0');
            updateCollapseControls(toggles, collapsed);
        });
    });
}

function updateCollapseControls(toggles: NodeListOf<HTMLButtonElement>, collapsed: boolean): void {
    toggles.forEach((toggle) => {
        const label = collapsed
            ? (toggle.dataset.labelExpand ?? '')
            : (toggle.dataset.labelCollapse ?? '');

        // aria-label for a11y; data-bs-title for NAIS Bootstrap tooltips.
        // Do NOT set native `title` — initBootstrapTooltips binds [title], and
        // re-setting title after Tooltip init causes native + BS double tooltip.
        toggle.setAttribute('aria-label', label);
        toggle.setAttribute('data-bs-title', label);
        toggle.removeAttribute('title');

        const tip = getBootstrapTooltip().getInstance(toggle);
        if (tip) {
            toggle.setAttribute('data-bs-original-title', label);
            tip.setContent({ '.tooltip-inner': label });
        }
    });
}
